// extracted by mini-css-extract-plugin
module.exports = {"tagline":"LogoStuff_tagline__2w2hc","brandName":"LogoStuff_brandName__31fOs","vert-move":"LogoStuff_vert-move__33jgU","mover":"LogoStuff_mover__3U_l2"};